import { Autocomplete, Box, Button, Checkbox, Divider, FormControlLabel, FormGroup, Grid, IconButton, InputAdornment, Modal, TextField } from "@mui/material";
import * as React from "react";
import { FC } from "react";
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import HighlightOffTwoToneIcon from '@mui/icons-material/HighlightOffTwoTone';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { makeStyles } from "@material-ui/core/styles";
import styled from "@emotion/styled";

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    transition: '0ms',
    width: 425,
    borderRadius: 2,
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
};

const useStyles = makeStyles({
    paper: {
      border: "1.5px solid #e9ecf1",
      width: '108%',
      boxShadow: 'none',
      marginLeft: '-6px',
      borderRadius: 7
    }
});

const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: 3,
    width: 15,
    height: 15,
    boxShadow:
    //   theme.palette.mode === 'dark'
        // ? '0 0 0 1px rgb(16 22 26 / 40%) ' :
        'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: 
    // theme.palette.mode === 'dark' ? '#394b59' : 
    '#f5f8fa',
    backgroundImage:
    //   theme.palette.mode === 'dark'
        // ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))' :
        'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: 
    //   theme.palette.mode === 'dark' ? '#30404d' : 
      '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background:
        // theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 
        'rgba(206,217,224,.5)',
    },
  }));
  
  const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#137cbd',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 15,
      height: 15,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  });

const VendeeModel: FC<any> = (props) => {

    const classes = useStyles();
    const [ship, setShip] = React.useState(false);
    const [address, setAddress] = React.useState(false);

    const onClose = () => {
        props.setVisible(false)
        setShip(false)
        setAddress(false)
    }

    return(
        <Modal
            open={props.visible}
            onClose={(event : any, reason:any) => {
                if (reason !== 'backdropClick') {
                    props.setVisible(true)
                }
            }}
        >
            <Box sx={style}>
            <Grid container>
                <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p:2, pl:2, bgcolor:'#e9ecf1' }} style={{borderTopLeftRadius:8,borderTopRightRadius:8,height:50}} >
                <div style={{float:'right',marginTop:-7,marginRight:-5}}>
                    <IconButton size='small' >
                        <CheckCircleOutlineOutlinedIcon  color="primary"/>
                    </IconButton>
                    {/* <Button variant="outlined" color="primary" style={{borderWidth:2.5,borderRadius:25,height:25,fontSize:12,paddingTop:6,paddingLeft:'0px',paddingRight:'0px',marginTop:1,width:'auto',minWidth:'50px'}}>Add</Button> */}
                    <IconButton size='small' onClick={onClose} style={{marginRight:-5}} >
                        <HighlightOffOutlinedIcon  color="error"/>
                    </IconButton>
                </div>
                <h3  style={{marginTop:-2}}>Create Party</h3>
                
                </Grid>
                
            </Grid>
            <Grid container spacing={2} p={2}>

                <Grid item xs={6}>
                <h5 className='c-label'>Party Name*</h5>
                <TextField 
                    placeholder='Party Name' 
                    required 
                    className='c-text-field' 
                    variant="standard" 
                    size='small'
                    InputProps={{
                    disableUnderline: true,
                    }} 
                />
                </Grid>

                <Grid item xs={6}>
                <h5 className='c-label'>Mobile Number</h5>
                <TextField 
                    placeholder='Mobile Number' 
                    required 
                    className='c-text-field' 
                    variant="standard" 
                    size='small'
                    InputProps={{
                    disableUnderline: true,
                    }} 
                />
                </Grid>

                <Grid item xs={6} mt={-1}>
                <h5 className='c-label'>GSTIN</h5>
                <TextField 
                    placeholder='GSTIN (Optional)' 
                    required 
                    className='c-text-field' 
                    variant="standard" 
                    size='small'
                    InputProps={{
                    disableUnderline: true,
                    }} 
                />
                </Grid>

                <Grid item xs={6} mt={-1}>
                <h5 className='c-label'>PAN Number</h5>
                <TextField 
                    placeholder='PAN Number (Optional)' 
                    required 
                    className='c-text-field' 
                    variant="standard" 
                    size='small'
                    InputProps={{
                    disableUnderline: true,
                    }} 
                />
                </Grid>
                
                <Grid item xs={12} mt={-1} mb={-1}>
                    <Divider/>
                    {!address ?
                    <label className="c_label" style={{color:'#488dff',cursor:'pointer',fontSize:13}}
                    onClick={()=> setAddress(!address)}>+ Add Address (Optional)</label> : ''}
                </Grid>
            </Grid>
            {address ?
            <>
            <HighlightOffTwoToneIcon 
            onClick={()=> {
                setAddress(false);
                setShip(false);
            }} sx={{float:'right',marginTop:'-8px',marginRight:0.8,color:'#9da7b7',fontSize:20}}/>
            <Box sx={{ p: 0, border: '1px dashed grey', borderRadius:'10px', m:1.5, mt:0, transition:'0.5s' }} >
            <Grid container spacing={2} p={2} pt={0}>
                <Grid item xs={12} mt={-2}>
                <h5 className='c-label'>Billing Address</h5>
                <TextField 
                    placeholder='Billing Address' 
                    required 
                    className='c-text-field' 
                    multiline
                    rows={2}
                    variant="standard" 
                    style={{width:'100%'}}
                    size='small'
                    InputProps={{
                        disableUnderline: true,
                        endAdornment: <InputAdornment position="end">
                        <TextField 
                            placeholder='Pincode' 
                            required 
                            className='c-text-field-2' 
                            style={{width:70,marginRight:5}}
                            variant="standard" 
                            size='small'
                            InputProps={{
                            disableUnderline: true,
                        }} 
                    /></InputAdornment>
                    }} 
                />
                </Grid>

                <Grid item xs={6} mt={-1}>
                <h5 className='c-label'>State</h5>
                <Autocomplete
                disablePortal
                forcePopupIcon={false}
                options={[
                    { label: 'Maharashtra' },
                    { label: 'Andra Pradesh' },
                    { label: 'karnataka' }
                ]}
                renderOption={(props, option: {label: string}) => (
                    <li {...props} 
                    style={{fontSize:14,height:28}}
                    >{option.label}</li>
                )}
                disableClearable={true}
                classes={{ paper: classes.paper }}
                sx={{ width: '100%'}}
                renderInput={(params) => <TextField {...params}
                    placeholder='Select State' 
                    required 
                    className='c-text-field' 
                    variant="standard" 
                    size='small'
                    InputProps={{...params.InputProps, disableUnderline: true}}
                />}
                />
                </Grid>

                <Grid item xs={6} mt={-1}>
                <h5 className='c-label'>City</h5>
                <TextField 
                    placeholder='City' 
                    required 
                    className='c-text-field' 
                    variant="standard" 
                    size='small'
                    InputProps={{
                    disableUnderline: true,
                    }} 
                />
                </Grid>

                <Grid item xs={12} mt={-1} mb={-1}>
                    <FormGroup style={{paddingLeft:5}}>
                    <FormControlLabel label="Shipping address same as billing address"
                    control={
                    <Checkbox
                    sx={{
                        '&:hover': { bgcolor: 'transparent' },
                    }}
                    defaultChecked
                    onClick={()=> setShip(!ship)}
                    disableRipple
                    checkedIcon={<BpCheckedIcon />}
                    icon={<BpIcon />}
                    />}/>
                    </FormGroup>
                </Grid>
            </Grid>
            {ship ? 
            <Grid container spacing={2} p={2} pt={0}>
                <Grid item xs={12}>
                <h5 className='c-label'>Shipping Address</h5>
                <TextField 
                    placeholder='Shipping Address' 
                    required 
                    className='c-text-field' 
                    multiline
                    rows={2}
                    variant="standard" 
                    style={{width:'100%'}}
                    size='small'
                    InputProps={{
                        disableUnderline: true,
                        endAdornment: <InputAdornment position="end"><TextField 
                        placeholder='Pincode' 
                        required 
                        className='c-text-field-2' 
                        style={{width:70,marginRight:5}}
                        variant="standard" 
                        size='small'
                        InputProps={{
                        disableUnderline: true,
                        }} 
                    /></InputAdornment>
                    }}  
                />
                </Grid>

                <Grid item xs={6} mt={-1}>
                <h5 className='c-label'>State</h5>
                <Autocomplete
                disablePortal
                forcePopupIcon={false}
                options={[
                    { label: 'Maharashtra' },
                    { label: 'Andra Pradesh' },
                    { label: 'karnataka' }
                ]}
                renderOption={(props, option: {label: string}) => (
                    <li {...props} 
                    style={{fontSize:14,height:28}}
                    >{option.label}</li>
                )}
                disableClearable={true}
                classes={{ paper: classes.paper }}
                sx={{ width: '100%'}}
                renderInput={(params) => <TextField {...params}
                    placeholder='Select State' 
                    required 
                    className='c-text-field' 
                    variant="standard" 
                    size='small'
                    InputProps={{...params.InputProps, disableUnderline: true}}
                />}
                />
                </Grid>

                <Grid item xs={6} mt={-1}>
                <h5 className='c-label'>City</h5>
                <TextField 
                    placeholder='City' 
                    required 
                    className='c-text-field' 
                    variant="standard" 
                    size='small'
                    InputProps={{
                    disableUnderline: true,
                    }} 
                />
                </Grid>
            </Grid> : ''}
            </Box> </> :''}

            </Box>
        </Modal>
    )
};
export default VendeeModel;